import * as S from './styles';

// BTW: this is also defined in the backend
export const monthsArray = {
  360: [1, 60, 120, 180, 240, 300, 360],
  200: [1, 33, 66, 100, 133, 166, 200], // temporarity adding it here as this is the max number returned from the endpoint /api/v2/contract-flow/calculate-fee
  180: [1, 30, 60, 90, 120, 150, 180],
  120: [1, 20, 40, 60, 80, 100, 120],
  108: [1, 18, 36, 54, 72, 90, 108],
  96: [1, 16, 32, 48, 64, 80, 96],
  89: [1, 15, 30, 45, 60, 75, 89],
  84: [1, 15, 30, 45, 60, 75, 84],
  72: [1, 12, 24, 36, 48, 60, 72],
  60: [1, 10, 20, 30, 40, 50, 60],
  48: [1, 8, 16, 24, 32, 40, 48],
  36: [1, 6, 12, 18, 24, 30, 36],
  24: [1, 4, 8, 12, 16, 20, 24],
};

export type RangeTypes = {
  months: keyof typeof monthsArray;
  initialValue: number;
  finalValue: number;
};

const Range = ({ months, initialValue, finalValue }: RangeTypes) => {
  return (
    <S.Wrapper>
      {monthsArray[months].map((item, index) => {
        const inRange = () => {
          const containsInRange = monthsArray[months].find(
            (item) => item === initialValue || item === finalValue
          );

          const verifyFirstValue = monthsArray[months].find(
            (item) => item === initialValue
          );

          const verifyLastValue = monthsArray[months].find(
            (item) => item === finalValue
          );

          if (initialValue > finalValue || initialValue === finalValue) {
            return false;
          }

          if (containsInRange && verifyLastValue && verifyFirstValue) {
            if (
              (item > initialValue && item < finalValue) ||
              item === initialValue ||
              item === finalValue
            ) {
              return true;
            }
          }

          return false;
        };

        const isSelected = (value: number) => {
          if (initialValue > finalValue) {
            return value === initialValue;
          }

          if (initialValue === item || finalValue === item) {
            return true;
          }

          return false;
        };

        return (
          <S.Item
            key={`item-${index}`}
            selected={isSelected(item)}
            range={inRange()}
            className={
              item === initialValue || item === finalValue ? 'selected' : ''
            }
          >
            {item}
          </S.Item>
        );
      })}
    </S.Wrapper>
  );
};

export default Range;
